import { supabase } from '../../providers/supabase/client'

// ── Flight Types ────────────────────────────────────────────────

export const fetchFlightTypes = async () => {
  return await supabase
    .from('flight_types')
    .select('*')
    .order('name', { ascending: true })
}

export const createFlightType = async (name: string, description?: string) => {
  return await supabase
    .from('flight_types')
    .insert([{ name, description }])
    .select()
}

// ── Airline Configurations ──────────────────────────────────────

export const fetchAirlineConfigurations = async (airlineId?: number) => {
  let query = supabase
    .from('airline_configurations')
    .select(`
      *,
      flight_types(*),
      aerolines(id, name, logo_url)
    `)
    .eq('is_active', true)
    .order('created_at', { ascending: true })

  if (airlineId) {
    query = query.eq('airline_id', airlineId)
  }

  return await query
}

export const fetchConfigurationsByAirlineIds = async (airlineIds: number[]) => {
  return await supabase
    .from('airline_configurations')
    .select(`
      *,
      flight_types(*),
      aerolines(id, name, logo_url)
    `)
    .in('airline_id', airlineIds)
    .eq('is_active', true)
    .order('airline_id', { ascending: true })
}

export const createAirlineConfiguration = async (config: {
  airline_id: number,
  flight_type_id: string,
  notes?: string
}) => {
  return await supabase
    .from('airline_configurations')
    .insert([config])
    .select(`
      *,
      flight_types(*),
      aerolines(id, name, logo_url)
    `)
}

export const updateAirlineConfiguration = async (id: string, data: {
  flight_type_id?: string,
  notes?: string,
  is_active?: boolean
}) => {
  return await supabase
    .from('airline_configurations')
    .update(data)
    .eq('id', id)
    .select(`
      *,
      flight_types(*),
      aerolines(id, name, logo_url)
    `)
}

export const deleteAirlineConfiguration = async (id: string) => {
  // Hard delete
  return await supabase
    .from('airline_configurations')
    .delete()
    .eq('id', id)
}

export const checkAirlineConfigurationInUse = async (id: string) => {
  return await supabase
    .from('reservations_aerolines')
    .select('reservations(id, clients(name))')
    .eq('airline_configuration_id', id)
}
